import { JsonViewModeContextProvider, ViewTypes } from 'ui/treeView';
import { PaginationContextProvider } from 'utils/contexts/pagination';
import { SortingContextProvider } from 'utils/contexts/sorting';

import { DEFAULT_SORTED_TABLE_COLUMN, DEFAULT_SORT_DIRECTION } from './constants';
import { EventHistoryFiltersContextProvider } from './contexts/EventHistoryFiltersContextProvider';
import { EventHistoryIndexHeader } from './header/EventHistoryIndexHeader';
import { EventHistoryModalsContextProvider } from './contexts/EventHistoryModalsContextProvider';
import { EventHistoryQueryContextProvider } from './contexts/EventHistoryQueryContextProvider';
import { EventHistoryTable } from './table/EventHistoryTable';
import { ResendMessageModal } from './ResendMessageModal';

export const EventHistoryContext = () => (
  <PaginationContextProvider>
    <SortingContextProvider
      defaultSortField={DEFAULT_SORTED_TABLE_COLUMN}
      defaultSortDirection={DEFAULT_SORT_DIRECTION}
    >
      <JsonViewModeContextProvider identifier="event-history" defaultMode={ViewTypes.table}>
        <EventHistoryFiltersContextProvider>
          <EventHistoryQueryContextProvider>
            <EventHistoryModalsContextProvider>
              <EventHistoryIndexHeader />
              <EventHistoryTable />
              <ResendMessageModal />
            </EventHistoryModalsContextProvider>
          </EventHistoryQueryContextProvider>
        </EventHistoryFiltersContextProvider>
      </JsonViewModeContextProvider>
    </SortingContextProvider>
  </PaginationContextProvider>
);
